"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeTxAuxiliaryData = void 0;
const internal_1 = require("../../types/internal");
const assert_1 = require("../../utils/assert");
const serialize_1 = require("../../utils/serialize");
function serializeTxAuxiliaryData(auxiliaryData) {
    const auxiliaryDataTypesEncoding = {
        [internal_1.TxAuxiliaryDataType.ARBITRARY_HASH]: 0x00,
        [internal_1.TxAuxiliaryDataType.CIP36_REGISTRATION]: 0x01,
    };
    switch (auxiliaryData.type) {
        case internal_1.TxAuxiliaryDataType.ARBITRARY_HASH: {
            return Buffer.concat([
                (0, serialize_1.uint8_to_buf)(auxiliaryDataTypesEncoding[auxiliaryData.type]),
                (0, serialize_1.hex_to_buf)(auxiliaryData.hashHex),
            ]);
        }
        case internal_1.TxAuxiliaryDataType.CIP36_REGISTRATION: {
            return Buffer.concat([
                (0, serialize_1.uint8_to_buf)(auxiliaryDataTypesEncoding[auxiliaryData.type]),
            ]);
        }
        default:
            (0, assert_1.unreachable)(auxiliaryData);
    }
}
exports.serializeTxAuxiliaryData = serializeTxAuxiliaryData;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHhBdXhpbGlhcnlEYXRhLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2ludGVyYWN0aW9ucy9zZXJpYWxpemF0aW9uL3R4QXV4aWxpYXJ5RGF0YS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSxtREFBd0Q7QUFDeEQsK0NBQThDO0FBQzlDLHFEQUE4RDtBQUU5RCxTQUFnQix3QkFBd0IsQ0FDdEMsYUFBb0M7SUFFcEMsTUFBTSwwQkFBMEIsR0FBRztRQUNqQyxDQUFDLDhCQUFtQixDQUFDLGNBQWMsQ0FBQyxFQUFFLElBQUk7UUFDMUMsQ0FBQyw4QkFBbUIsQ0FBQyxrQkFBa0IsQ0FBQyxFQUFFLElBQUk7S0FDdEMsQ0FBQTtJQUVWLFFBQVEsYUFBYSxDQUFDLElBQUksRUFBRTtRQUMxQixLQUFLLDhCQUFtQixDQUFDLGNBQWMsQ0FBQyxDQUFDO1lBQ3ZDLE9BQU8sTUFBTSxDQUFDLE1BQU0sQ0FBQztnQkFDbkIsSUFBQSx3QkFBWSxFQUFDLDBCQUEwQixDQUFDLGFBQWEsQ0FBQyxJQUFJLENBQVksQ0FBQztnQkFDdkUsSUFBQSxzQkFBVSxFQUFDLGFBQWEsQ0FBQyxPQUFPLENBQUM7YUFDbEMsQ0FBQyxDQUFBO1NBQ0g7UUFDRCxLQUFLLDhCQUFtQixDQUFDLGtCQUFrQixDQUFDLENBQUM7WUFDM0MsT0FBTyxNQUFNLENBQUMsTUFBTSxDQUFDO2dCQUNuQixJQUFBLHdCQUFZLEVBQUMsMEJBQTBCLENBQUMsYUFBYSxDQUFDLElBQUksQ0FBWSxDQUFDO2FBQ3hFLENBQUMsQ0FBQTtTQUNIO1FBQ0Q7WUFDRSxJQUFBLG9CQUFXLEVBQUMsYUFBYSxDQUFDLENBQUE7S0FDN0I7QUFDSCxDQUFDO0FBdkJELDREQXVCQyJ9